@let passenger = passenger$ | async;

<header></header>

<div class="container">
  @if (passenger) {
    <div class="d-flex d-md-none align-items-center">
      <ds-button
        (click)="goBack()"
        variant="icon"
        icon="chevronLeft"
        label="Back"
        size="s"
        data-id="back"
      />

      <h3 class="semi-bold ml-3" data-id="fullname">{{ passenger?.fullName }}</h3>
    </div>

    <div class="d-none d-md-flex align-items-center">
      <ds-button (click)="goBack()" variant="icon" icon="chevronLeft" label="Back" data-id="back" />

      <h1 class="semi-bold ml-5" data-id="fullname">{{ passenger?.fullName }}</h1>
    </div>

    <ds-card class="d-flex flex-column p-6 card">
      <div class="d-flex align-items-center">
        <img src="assets/icons/lock.svg" width="20" height="20" alt="lock" />
        <h3 class="semi-bold ml-1">Traveler identity</h3>
      </div>

      <p class="mt-2">
        These details must match your passport exactly and can only be updated by a travel expert.
      </p>

      <div class="mt-4 items">
        <div class="d-flex flex-column">
          <p class="semi-bold">Full Name</p>
          <p class="mt-1" data-id="fullname">{{ passenger?.fullName }}</p>
        </div>

        <div class="d-flex flex-column">
          <p class="semi-bold">Date of birth</p>
          <p class="mt-1" data-id="birthdate">{{ passenger?.birthday | date }}</p>
        </div>

        <div class="d-flex flex-column">
          <p class="semi-bold">Gender</p>
          <p class="mt-1" data-id="gender">{{ passenger?.gender | label }}</p>
        </div>

        <div class="d-flex flex-column">
          @let country = passenger?.countryId | getCountryById | async;

          <p class="semi-bold">Citizenship</p>
          <p class="mt-1" data-id="country">{{ country?.label }}</p>
        </div>
      </div>
    </ds-card>

    <client-traveler-form (formSubmit)="formSubmit($event)" [model]="passenger" [errors]="errors" />
  } @else {
    <ds-skeleton class="passengers-page-body-item" [height]="44" />
    <ds-skeleton class="passengers-page-body-item" [height]="328" />
    <ds-skeleton class="passengers-page-body-item" [height]="156" />
  }
</div>
